import * as types from "../actions/types/signin.types";

const initialState = {
    loginStatus: "initial",
    loginErrorMsg: "",
    user: {
        docs: {
            residentPermitFileUrl: "",
            utilityBillFileUrl: "",
        },
        updateFlag: "none",
    },
    fromLogin: false,
    smeUserID: "",
    smeEmail: "",
    validateOtpState: "idle",
};

export const signInReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.LOGIN_STARTED:
            return {
                ...state,
                loginStatus: "loading",
            };
        case types.LOGIN_SUCCEDEED:
            return {
                ...state,
                loginStatus: "success",
                fromLogin: true,
                user: {
                    ...state.user,
                    password: action.payload.password,
                    //tokenId: action.payload.tokenId,
                    newToBankUser: action.payload.newToBankUser
                },

            };
        case types.LOGIN_FAILED:
            return {
                ...state,
                loginStatus: "failed",
                loginErrorMsg: action.payload,
            };
        case types.VALIDATE_OTP_STARTED:
            return {
                ...state,
                validateOtpState: "loading",
            };
        case types.VALIDATE_OTP_SUCCEDEED:
            return {
                ...state,
                validateOtpState: "success",
                smeUserID: action.payload.id,
                smeEmail: action.payload.email,
                user: { ...state.user, userID: action.payload.id, password: "", tokenId: "" },
            };
        case types.VALIDATE_OTP_FAILED:
            return {
                ...state,
                validateOtpState: "failed",
            };
        default:
            return state;
    }
};
